import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

function AppBarStandard({ title, description, options = [] }) {
	const navigate = useNavigate();
	return (
		<>
			<div className="flex justify-between gap-2">
				<Button variant="ghost" onClick={() => { navigate('/home') }}>
					<ChevronLeft />
					Back to Home
				</Button>
				<div>
					{options}
				</div>
			</div>
			<h1 className='text-3xl md:text-4xl lg:text-5xl font-extrabold drop-shadow-lg mt-2'>{title}</h1>
			<p className='mt-1'>
				{description}
			</p>
		</>
	);
}
export default AppBarStandard;